import { render } from "./Quickstart.vue?vue&type=template&id=07c3f490&scoped=true"
import script from "./Quickstart.vue?vue&type=script&lang=js"
export * from "./Quickstart.vue?vue&type=script&lang=js"

import "./Quickstart.vue?vue&type=style&index=0&id=07c3f490&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c3f490"]])

export default __exports__